import React, { createContext, useContext, useState, useEffect } from 'react';
import { PermissionType, UserContext } from './UserProvider';

const PermissionsContext = createContext<PermissionType[]>([]);

export const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
	const { myUser } = useContext(UserContext);
	const [permissions, setPermissions] = useState<PermissionType[]>(myUser?.permissions || []);

	// Aggiorna permissions quando cambia user
	useEffect(() => {
		if (myUser && Array.isArray(myUser.permissions)) {
			setPermissions(myUser.permissions);
		}
	}, [myUser]);

	return <PermissionsContext.Provider value={permissions}>{children}</PermissionsContext.Provider>;
};

export const usePermissions = () => useContext(PermissionsContext);

/* 
    ESEMPIO DI UTILIZZO: Pulsanti, sezioni, elementi UI

    <WithPermission permission="create-project"> <-- se un permesso
        <button>Nuovo Progetto</button>
    </WithPermission>

    <WithPermission permission={["edit-project", "delete-project"]}> <-- se almeno un permesso
        <button>Azioni Avanzate</button>
    </WithPermission>

    <WithPermission permission={["publish", "approve"]} mode="all"> <-- se tutti i permessi
        <button>Pubblica Progetto</button>
    </WithPermission>

    --------------------------------------------------------

    ESEMPIO DI UTILIZZO: Intere pagine

    const SettingsPage = () => {
        const hasPermission = useHasPermission(["view-settings", "edit-settings"], "all");  <--- array delle key + modalità "all" o "any"

        if (!hasPermission) return <Unauthorized />;

        return <ProjectsList />;
    };
*/
